const DELETE_DOCUMENT_TYPE = 'DELETE_DOCUMENT_TYPE';
const SAVE_DOCUMENT_TYPE = 'SAVE_DOCUMENT_TYPE';
const CHANGE_FOLDER_FOR_DEFAULT_OPTIONS = 'CHANGE_FOLDER_FOR_DEFAULT_OPTIONS';

export default {
    DELETE_DOCUMENT_TYPE,
    CHANGE_FOLDER_FOR_DEFAULT_OPTIONS,
    SAVE_DOCUMENT_TYPE
};
